// Module
var code = "<mat-paginator [ngClass]=\"matPaginatorClass\" [length]=\"length\" [pageSize]=\"pageSize\" [hidePageSize]=\"true\" [showFirstLastButtons]=\"true\" (page)=\"changePage($event)\" [pageIndex]=\"pageIndex\"> </mat-paginator>";
// Exports
module.exports = code;